import React from 'react';
import { View, Text, StyleSheet, ScrollView, Image, ImageBackground, Platform, useWindowDimensions, TouchableOpacity, Linking } from 'react-native';
import { colores, fuentes } from '../../styles/variablesCss';

const ReportesSociales = () => {
  const { width } = useWindowDimensions();
  const isSmall = width < 576;
  const isMedium = width >= 576 && width < 992;

  const heroHeight = isSmall ? 280 : isMedium ? 420 : 580;
  const lineFont = isSmall ? 36 : isMedium ? 56 : 75;
  const lineHeight = lineFont;
  const textBlockBottom = isSmall ? 24 : 40;
  const textBlockMarginLeft = isSmall ? '6%' : '12%';
  const breadcrumbFont = isSmall ? 11 : 12;
  const contentPaddingV = isSmall ? 16 : 20;
  const titleSize = isSmall ? 24 : 32;
  const bodyFont = isSmall ? 14 : 16;

  const years = [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021];

  const numColumns = isSmall ? 1 : isMedium ? 2 : 3;
  const imageWidth = isSmall ? '100%' : isMedium ? '48%' : '31%';

  const handleOpenPDF = (year) => {
    const pdfUrl = `https://www.pinguino.com.ar/static/RSE/RSE${year}.pdf`;
    if (Platform.OS === 'web') {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    } else {
      Linking.openURL(pdfUrl).catch((err) => console.error('Error opening PDF:', err));
    }
  };

  return (
    <ScrollView contentContainerStyle={styles.page}>
      <View style={[styles.contentWrap, { paddingVertical: contentPaddingV }]}>
        <Text style={[styles.title, { fontSize: titleSize }]}>Reportes Sociales</Text>

        <View style={styles.imagesGrid}>
          {years.map((year) => (
            <TouchableOpacity 
              key={year} 
              style={[styles.imageContainer, { width: imageWidth }]}
              onPress={() => handleOpenPDF(year)}
              activeOpacity={0.7}
            >
              <Image
                source={{ uri: `https://www.pinguino.com.ar/static/img/rse/RSE${year}.png` }}
                style={styles.reportImage}
                resizeMode="contain"
              />
              <Text style={styles.imageCaption}>RSE {year}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 0,
  },
  hero: {
    width: '100%',
    alignSelf: 'center',
  },
  heroImage: {
    width: '100%',
    height: 580,
    position: 'relative',
  },
  heroImageInner: {
  },
  overlay: {
    ...Platform.select({
      web: { backgroundColor: 'rgba(0,0,0,0.0)' },
      default: { backgroundColor: 'transparent' },
    }),
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  textBlock: {
    marginLeft: '12%',
    position: 'absolute',
    left: 24,
    bottom: 40,
  },
  line: {
    fontFamily: fuentes.bold,
    fontSize: 75,
    lineHeight: 75,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    marginBottom: 6,
    ...Platform.select({
      web: { textShadow: '0 2px 6px rgba(0,0,0,0.25)' },
      default: {},
    }),
  },
  white: {
    color: '#ffffff',
  },
  red: {
    color: colores.rojo,
  },
  breadcrumb: {
    marginLeft: '12%',
    position: 'absolute',
    top: 8,
    left: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  breadcrumbText: {
    color: '#fff',
    fontSize: 12,
    letterSpacing: 0.2,
  },
  breadcrumbBold: {
    fontFamily: fuentes.bold,
  },
  contentWrap: {
    backgroundColor: colores.blanco,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  title: {
    fontFamily: fuentes.bold,
    fontSize: 32,
    color: colores.rojo,
    marginBottom: 16,
    textAlign: 'center',
  },
  paragraph: {
    fontSize: 16,
    color: colores.texto,
    lineHeight: 24,
    marginBottom: 24,
    textAlign: 'center',
    maxWidth: 900,
    alignSelf: 'center',
  },
  imagesGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    gap: 16,
    maxWidth: 1200,
    alignSelf: 'center',
    width: '100%',
  },
  imageContainer: {
    marginBottom: 24,
    alignItems: 'center',
  },
  reportImage: {
    width: '100%',
    aspectRatio: 0.7,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: colores.grisClaro,
    backgroundColor: colores.blanco,
  },
  imageCaption: {
    marginTop: 8,
    fontSize: 14,
    fontFamily: fuentes.semiBold,
    color: colores.texto,
    textAlign: 'center',
  },
});

export default ReportesSociales;
